import React from "react";
import PropTypes from "prop-types";
import { Notebook } from "@learningblocks/storybook-components";
import { ReactDrawer } from "@learningblocks/storybook-components";
import { Utilities } from "@learningblocks/exp-constants";
const { getLocalStorageItem, NOTEBOOK, TOUR_PROPERTIES } = Utilities;
import { CommonSectionContent } from "./CommonSectionContent";
import { DesignSectionContent } from "./DesignSectionContent";
import style from "./style.module.scss";

/**
 * NotebookExpDesignWeb:
 * - Used to display the Nootbook of experimental design [ Web view]
 */
export function NotebookExpDesignWeb(props) {
  const isDesignSection = () =>
    props.currentMenu.value === NOTEBOOK.SECTION.DESIGN;

  const isExperimentalDesignComplete = getLocalStorageItem(
    TOUR_PROPERTIES.IS_EXPERIMENTAL_DESIGN_FINISHED
  );

  const renderContent = () => {
    if (!props.currentMenu) {
      return null;
    } else if (isDesignSection()) {
      !isExperimentalDesignComplete && props.startTour();
      return (
        <DesignSectionContent
          title={props.title}
          currentMenu={props.currentMenu}
          description={props.description}
          goToSection={props.onSetChapter}
          nextMenuValue={props.nextMenuValue}
          setNotebookVisible={props.onSetCollapse}
          options={props.options}
          viewType={props.viewType}
          onClickInfo={props.startTour}
        />
      );
    } else {
      return (
        <CommonSectionContent
          title={props.title}
          menuList={props.menuList}
          components={props.components}
          currentMenu={props.currentMenu}
          description={props.description}
          goToSection={props.onSetChapter}
          nextMenuValue={props.nextMenuValue}
          setNotebookVisible={props.onSetCollapse}
          collapsed={props.drawerCollapsed}
        />
      );
    }
  };

  const renderDrawerCollapsed = () => {
    if (props.drawerCollapsed) {
      return (
        <Notebook.DrawerIcon
          collapsed={true}
          toggleCollapse={props.onSetCollapse}
        />
      );
    } else {
      return null;
    }
  };

  const getShowOverlay = () => !isDesignSection();

  return (
    <>
      {renderDrawerCollapsed()}
      <ReactDrawer
        showOverlay={getShowOverlay()}
        visible={!props.drawerCollapsed}
      >
        <Notebook.Wrapper className={style.book}>
          {renderContent()}
        </Notebook.Wrapper>
      </ReactDrawer>
    </>
  );
}

NotebookExpDesignWeb.propTypes = {
  /**
   * Components in current section to be displayed in Notebook
   */
  components: PropTypes.arrayOf(PropTypes.object),
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * Description to be displayed in Notebook Header
   */
  description: PropTypes.string,
  /**
   * Function to set new Chapter
   */
  onSetChapter: PropTypes.func,
  /**
   * To show or hide Notebook
   */
  drawerCollapsed: PropTypes.bool,
  /**
   * List of Menu Items
   */
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title to display in  menu
       */
      title: PropTypes.string.isRequired,
      /**
       * Boolean specifying if menu is selected
       */
      current: PropTypes.bool.isRequired,
      /**
       * Index number of menu
       */
      number: PropTypes.number.isRequired,
      /**
       * Unique string value of the menu
       */
      value: PropTypes.string.isRequired,
      /**
       * Boolean set when section is visited
       */
      visited: PropTypes.bool.isRequired,
    })
  ),
  /**
   * Value for next-in-line menu
   * NONE value mens no more next section
   */
  nextMenuValue: PropTypes.oneOf([
    "CONTEXT",
    "TECHNIQUES",
    "DESIGN",
    "PROBLEM_SOLVING",
    "RESULTS",
    "REFLECTION",
    "TROUBLESHOOTING",
  ]),
  /**
   * Function to set new isNotebookVisible value
   */
  setNotebookVisible: PropTypes.func,
  /**
   * Title of the Content to display at header
   */
  title: PropTypes.string,
  /**
   * function to start Page Tour
   */
  startTour: PropTypes.func,
};

NotebookExpDesignWeb.defaultProps = {
  title: "",
  description: "",
};
